import moment from 'moment';
import {find} from 'lodash-es';

import {HISTORY_ADDED, HISTORY_UPDATED} from './history.action';

import {INITIAL_STATE} from './history.state';

export const HistoryReducer = (state = INITIAL_STATE, {type, payload}) => {
  switch (type) {
    case HISTORY_ADDED: {
      return {...state, list: addOrUpdateHistory(state, payload)};
    }

    case HISTORY_UPDATED: {
      const history = [...state.list];
      const newList = history.map(history => syncWithFavourites(history, payload));
      return {...state, list: newList};
    }

    default:
      return state;
  }
};

const syncWithFavourites = (history, favourites) => {
  const match = find(favourites, fav => fav.search.hash === history.search.hash);

  if (match) {
    return {...history, name: match.name, isFavourite: true};
  }

  return {...history, name: (history.search.query || []).join(','), isFavourite: false};
};

const addOrUpdateHistory = (state, payload) => {
  let history = state.list || [];
  const search = {...payload};

  const itemIndex = history.findIndex(element => element.search.hash === search.hash);

  if (itemIndex !== -1) {
    // current search was already in the history, update the timestamp
    history[itemIndex].search.searchTime = moment().utc();
  } else {
    // no item matching the current search was found
    const newHistory = new History(search);
    history.push(newHistory);
  }

  return [...history];
};

export class History {
  constructor(search = {}) {
    this.name = (search.query || []).join(',');
    this.isFavourite = false;
    this.search = {};
    this.search.query = [...search.query];
    this.search.alerts = this.getSelected(search.alerts);
    this.search.maintenance = this.getSelected(search.maintenance);
    this.search.lastCommunicated = this.getSelected(search.lastCommunicated);
    this.search.securityGroups = this.getSelected(search.securityGroups);
    this.search.tagFilters = search.tagFilters || {};
    this.search.searchTime = moment().utc();
    this.search.hash = search.hash;
    this.search.accounts = this.getSelected(search.accounts);
    //make last seen collection of object {min,max}
    this.search.lastSeen = (search.lastSeen || []).map(ls => {
      let {min, max} = ls.range || {};
      //to create the object by the one has value only will cast empty, null, to undefined
      min = min || undefined;
      max = max || undefined;
      return {min, max};
    });
  }

  getSelected(collection = []) {
    return collection
      .filter(item => item._selected)
      .map(selected => {
        return {id: selected.id};
      });
  }
}
